import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import API from 'utils/api'
import { CLEAR_RESOURCES } from 'store/resources/types'
import { CLEAR_STATUS } from 'store/ui/types'
import { showErrorMessage, showInfoMessage } from 'store/ui/actions'

export const addThirdPartyIntercom = createAsyncThunk(
  'intercoms/addThirdParty',
  async ({ ...args }, { getState, rejectWithValue, dispatch }) => {
    try {
      const payload = await API.request(`/foreign_intercoms`, {
        method: 'POST',
        body: JSON.stringify({ ...args }),
      })
      dispatch(showInfoMessage(payload?.message))
      return payload
    } catch (err) {
      const { error } = await err.json()
      dispatch(showErrorMessage(error))
      return rejectWithValue(err)
    }
  }
)

export const updateThirdPartyIntercom = createAsyncThunk(
  'intercoms/editThirdParty',
  async ({ uuid, ...args }, { getState, rejectWithValue, dispatch }) => {
    try {
      const payload = await API.request(`/foreign_intercoms/${uuid}`, {
        method: 'PATCH',
        body: JSON.stringify({ ...args }),
      })
      dispatch(showInfoMessage(payload?.message))
      return payload
    } catch (err) {
      const { error } = await err.json()
      dispatch(showErrorMessage(error))
      return rejectWithValue(err)
    }
  }
)

export const getThirdPartyIntercom = createAsyncThunk(
  'intercoms/getThirdParty',
  async (uuid, { getState, rejectWithValue, dispatch }) => {
    try {
      const payload = await API.request(`/foreign_intercoms/${uuid}`)
      return Promise.resolve(payload)
    } catch (err) {
      const { error } = await err.json()
      dispatch(showErrorMessage(error))
      return rejectWithValue(err)
    }
  }
)

const initialState = {
  msg: '',
  error: '',
  pending: false,
}

// reducers
export const intercomsSlice = createSlice({
  name: 'intercoms',
  initialState,
  reducers: {
    clearIntercomsStore: () => initialState,
  },
  extraReducers: {
    [CLEAR_RESOURCES]: () => initialState,
    [CLEAR_STATUS]: (state) => {
      state.msg = ''
      state.error = ''
    },

    [getThirdPartyIntercom.pending]: (state) => {
      state.pending = true
    },
    [getThirdPartyIntercom.fulfilled]: (state, { payload }) => {
      state.current = payload
      state.pending = false
    },
    [getThirdPartyIntercom.rejected]: (state) => {
      state.pending = false
    },
  },
})
export const { actions } = intercomsSlice
export default intercomsSlice.reducer
